import React from 'react';

import { Button } from '@/components/ui/button';

import { useExecutionDisplay } from '../hooks/useExecutionDisplay';
import { useTradingStore } from '../store';

const PERCENTAGES = [0.25, 0.5, 0.75, 1] as const;

// ── PercentageGrid ──────────────────────────────────────────────────────

interface PercentageGridProps {
    compact?: boolean;
    onSelect?: () => void;
}

export const PercentageGrid: React.FC<PercentageGridProps> = ({
    compact,
    onSelect,
}) => {
    const balance = useTradingStore((s) => s.balance);
    const setPercentage = useTradingStore((s) => s.setPercentage);
    const { executionInFlight } = useExecutionDisplay();

    return (
        <div
            className={
                compact
                    ? 'grid grid-cols-4 gap-2'
                    : 'mb-4 grid grid-cols-4 gap-2'
            }
        >
            {PERCENTAGES.map((pct) => (
                <Button
                    key={pct}
                    variant={compact ? 'outline' : 'ghost'}
                    size="sm"
                    onClick={() => {
                        setPercentage(pct);
                        onSelect?.();
                    }}
                    disabled={balance === 0 || (!compact && executionInFlight)}
                    className={
                        compact
                            ? 'font-mono text-xs font-semibold'
                            : 'font-mono text-[10px] font-semibold'
                    }
                >
                    {pct === 1 ? 'MAX' : `${pct * 100}%`}
                </Button>
            ))}
        </div>
    );
};
